import { IPricesState } from './types';

export const SLICE_NAMESPACE = 'zones';

export const initialState: IPricesState = {
  priceGroups: [],
  isLoading: false,
};
